import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import UtilsService from '../../services/UtilsService';
import { fadeInDelay } from '../animation/AnimationUtils';

export const BackdropStyle = ({
    root: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: '1',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        transition: 'opacity 100ms linear',
        '&.opening': {
            opacity: '1',
        },
        '&.closing': {
            opacity: '0',
        },
        '&.transparent': {
            backgroundColor: 'transparent',
        },
        ...fadeInDelay(100),
    },
});

const Backdrop = (props) => {
    const {
        testId = 'backdrop',
        classes,
        className,
        isOpening,
        isClosing,
        onClick,
        transparent,
    } = props;
    const rootClasses = UtilsService.getClassName([
        classes.root,
        className,
        transparent ? 'transparent' : '',
        isOpening ? 'opening' : '',
        isClosing ? 'closing' : '',
    ]);

    return <div
        data-test-id={testId}
        onClick={(e) => {
            e.stopPropagation();

            onClick();
        }}
        className={rootClasses}
    />;
};

Backdrop.propTypes = {
    testId: PropTypes.string,
    className: PropTypes.string,
    classes: PropTypes.object,
    onClick: PropTypes.func,
    isOpening: PropTypes.bool,
    isClosing: PropTypes.bool,
    transparent: PropTypes.bool,
};

export default withStyles(BackdropStyle)(Backdrop);
